export { default } from './Signup';
export { default as template } from './signup.tpl';
